import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseStep1Layout, BaseStep1LayoutProps } from "../shared/BaseStep1Layout";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

export type TicketingStep1LayoutProps = Omit<BaseStep1LayoutProps, "slots"> & {
  additionalDonationPosition: "top-of-page" | "default";
  slots: {
    banner?: React.ReactNode;
    welcomeBackBanner?: React.ReactNode;
    summary: React.ReactNode;
    coreInfo?: React.ReactNode;
    welcomeMessage?: React.ReactNode;
    additionalDonation: React.ReactNode;
    prizes?: React.ReactNode;
    rates: React.ReactNode;
    drawingInfo?: React.ReactNode;
    drawingRules?: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
    mobileChooseTicketsFloatingButton?: React.ReactNode;
    divider?: React.ReactNode;
    shopCartButton?: React.ReactNode;
  };
};

export const TicketingStep1Layout: FC<TicketingStep1LayoutProps> = ({
  slots,
  additionalDonationPosition = "default",
  isEmbed,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  const showCoreInfoInOrderSlot = !isSmallScreen || isEmbed;

  return (
    <BaseStep1Layout
      {...rest}
      isEmbed={isEmbed}
      slots={{
        banner: slots.banner,
        welcomeBackBanner: slots.welcomeBackBanner,
        info: slots.summary,
        order: (
          <Stack width="100%" gap={2}>
            {showCoreInfoInOrderSlot && slots.coreInfo}
            {showCoreInfoInOrderSlot && !isEmbed && slots.divider}
            {additionalDonationPosition === "top-of-page" && slots.additionalDonation}
            {slots.welcomeMessage}
            {slots.prizes}
            {slots.rates}
            {additionalDonationPosition === "default" && slots.additionalDonation}
            {slots.drawingInfo}
            {isSmallScreen && !isEmbed && slots.divider}
            <Stack width="100%" gap={1}>
              {slots.generateReceipt}
              {slots.zeffyBusinessModel}
            </Stack>
            {slots.drawingRules}
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
        mobileChooseTicketsFloatingButton: slots.mobileChooseTicketsFloatingButton,
        shopCartButton: slots.shopCartButton,
      }}
    />
  );
};
